import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import Weekdays from './Weekdays';
import Day from './Day';
import { ENTER } from './keys';
import * as ModifiersUtils from './ModifiersUtils';
import * as Helpers from './Helpers';
import * as DateUtils from './DateUtils';

var Month = /*#__PURE__*/function () {
  var Month = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Month, _Component);

    function Month() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;

      _this.renderDay = function (day) {
        var monthNumber = _this.props.month.getMonth();

        var propModifiers = Helpers.getModifiersFromProps(_this.props);
        var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);

        if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
          dayModifiers.push(_this.props.classNames.today);
        }

        if (day.getMonth() !== monthNumber) {
          dayModifiers.push(_this.props.classNames.outside);
        }

        var isOutside = day.getMonth() !== monthNumber;
        var tabIndex = -1; // Focus on the first day of the month

        if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
          tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
        }

        var key = "" + day.getFullYear() + day.getMonth() + day.getDate();
        var modifiers = {};
        dayModifiers.forEach(function (modifier) {
          modifiers[modifier] = true;
        });
        return /*#__PURE__*/React.createElement(Day, {
          key: "" + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
          ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        }, _this.props.renderDay(day, modifiers));
      };

      return _this;
    }

    var _proto = Month.prototype;

    _proto.render = function render() {
      var _this2 = this;

      var _this$props = this.props,
          classNames = _this$props.classNames,
          month = _this$props.month,
          months = _this$props.months,
          fixedWeeks = _this$props.fixedWeeks,
          captionElement = _this$props.captionElement,
          weekdayElement = _this$props.weekdayElement,
          locale = _this$props.locale,
          localeUtils = _this$props.localeUtils,
          weekdaysLong = _this$props.weekdaysLong,
          weekdaysShort = _this$props.weekdaysShort,
          firstDayOfWeek = _this$props.firstDayOfWeek,
          onCaptionClick = _this$props.onCaptionClick,
          showWeekNumbers = _this$props.showWeekNumbers,
          showWeekDays = _this$props.showWeekDays,
          onWeekClick = _this$props.onWeekClick;
      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = /*#__PURE__*/React.isValidElement(captionElement) ? /*#__PURE__*/React.cloneElement(captionElement, captionProps) : /*#__PURE__*/React.createElement(captionElement, captionProps);
      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return /*#__PURE__*/React.createElement("div", {
        className: classNames.month,
        role: "grid"
      }, caption, showWeekDays && /*#__PURE__*/React.createElement(Weekdays, {
        classNames: classNames,
        weekdaysShort: weekdaysShort,
        weekdaysLong: weekdaysLong,
        firstDayOfWeek: firstDayOfWeek,
        showWeekNumbers: showWeekNumbers,
        locale: locale,
        localeUtils: localeUtils,
        weekdayElement: weekdayElement
      }), /*#__PURE__*/React.createElement("div", {
        className: classNames.body,
        role: "rowgroup"
      }, weeks.map(function (week) {
        var weekNumber;

        if (showWeekNumbers) {
          weekNumber = DateUtils.getWeekNumber(week[6]);
        }

        return /*#__PURE__*/React.createElement("div", {
          key: week[0].getTime(),
          className: classNames.week,
          role: "row"
        }, showWeekNumbers && /*#__PURE__*/React.createElement("div", {
          className: classNames.weekNumber,
          tabIndex: onWeekClick ? 0 : -1,
          role: "gridcell",
          onClick: onWeekClick ? function (e) {
            return onWeekClick(weekNumber, week, e);
          } : undefined,
          onKeyUp: onWeekClick ? function (e) {
            return e.keyCode === ENTER && onWeekClick(weekNumber, week, e);
          } : undefined
        }, _this2.props.renderWeek(weekNumber, week, month)), week.map(_this2.renderDay));
      })));
    };

    return Month;
  }(Component);

  return Month;
}();

export default Month;